import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { RouteProvider } from "./context/RouteContext";
import { CartProvider } from "./context/CartContext";
import { BookmarksProvider } from "./context/BookmarksContext";

import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import TravellerDock from "./components/TravellerDock";
import PageviewTracker from "./components/PageviewTracker";

import Landing from "./pages/Landing";
import Search from "./pages/Search";
import PlanTrip from "./pages/PlanTrip";
import MapPage from "./pages/MapPage";
import Passport from "./pages/Passport";
import Saved from "./pages/Saved";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CityDetail from "./pages/CityDetail";
import FeaturedRoutesPage from "./pages/FeaturedRoutesPage";
import FeaturedRouteDetail from "./pages/FeaturedRouteDetail";
import Groups from "./pages/Groups";
import Schools from "./pages/Schools";
import Admin from "./pages/Admin";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import NotFound from "./pages/NotFound";

/** Fills the iOS safe area (notch/dynamic island) with the app background */
function SafeAreaTop() {
  return (
    <div
      className="fixed top-0 inset-x-0 z-50 bg-ink pointer-events-none"
      style={{ height: "env(safe-area-inset-top, 0px)" }}
      aria-hidden="true"
    />
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-ink text-cream">
      <BrowserRouter>
        <AuthProvider>
          <RouteProvider>
            <CartProvider>
            <BookmarksProvider>
            <PageviewTracker />
            <SafeAreaTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/search" element={<Search />} />
              <Route path="/plan-trip" element={<PlanTrip />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/city/:slug" element={<CityDetail />} />
              <Route path="/routes" element={<FeaturedRoutesPage />} />
              <Route path="/routes/:slug" element={<FeaturedRouteDetail />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/schools" element={<Schools />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route
                path="/passport"
                element={
                  <ProtectedRoute>
                    <Passport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/saved"
                element={
                  <ProtectedRoute>
                    <Saved />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/logs"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin defaultTab="logs" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <TravellerDock />
            <Toaster
              theme="dark"
              position="bottom-right"
              offset={{ bottom: "88px" }}
              mobileOffset={{ bottom: "88px" }}
              toastOptions={{
                style: {
                  background: "#0d1525",
                  border: "1px solid #1a283a",
                  color: "#f5f0e1",
                  fontFamily: "Inter, sans-serif",
                  borderRadius: "2px",
                },
              }}
            />
            </BookmarksProvider>
            </CartProvider>
          </RouteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
